<template>
  <div class="header">
    <div class="headTop" @click="goReturn">
      <div class="head_right">
        <div class="text" @click="goLogin" v-if="loginTrue">点击登录</div>
        <div class="text" v-else>
          {{ userInfo.rdname }} | <span @click="handleLogOut">退出</span>
        </div>

        <div v-if="avatar" class="login" @click="userinfo">
          <!-- <img :src="userInfo.virtualAvatar" alt="" /> -->
              <img v-if="avatar " :src="avatar" alt="" />

        </div>
        <div v-else class="login" @click="userinfo">
          <img src="@/assets/image/login.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import remToggle from "@/utils/rem-toggle.js";
import { logOut } from "@/api/basics/banner";
import Cookies from "js-cookie";
export default {
  mixins: [remToggle],
  props: {
    menuName: {
      type: String,
      default: "首页",
    },
  },
  data() {
    return {
      loginTrue: true,
      userInfo: "",
    };
  },
   computed: {
    // 映射store中的avatar getter
    ...mapGetters(['avatar'])
  },
  created() {
    const user = this.$store.state.userInfo;
    console.log(user, "用户信息");

    if (user && user.rdname) {
      // ✅ 关键字段存在才算登录
      this.loginTrue = false;
      this.userInfo = user;
    } else {
      this.loginTrue = true;
      this.userInfo = {};
    }
  },
  methods: {
    // goLogin() {
    //   console.log('1111111');
    //   this.$router.push({
    //     path: "/User/Login",
    //   });

    // },
      goLogin() {
      console.log('1111111');
      // 修复1：先判断当前是否已经在登录页，避免重复跳转
      const currentPath = this.$router.currentRoute.path;
      if (currentPath !== '/User/Login') {
        // 修复2：统一捕获所有跳转错误（包括重复导航）
        this.$router.push({
          path: "/User/Login",
        }).catch(err => {
          // 只忽略重复导航错误，其他错误正常打印
          if (err.name !== 'NavigationDuplicated') {
            console.error('跳转登录页失败：', err);
          }
        });
      }
    },

    goReturn() {
      this.$router.push({
        path: "/",
      });
    },
    handleLogOut() {
      logOut().then((res) => {
        if (res.data.code == 200) {
          this.$message.success(res.data.msg);
          this.loginTrue = true;
          this.userInfo = {};
          Cookies.remove("ticket");
          this.$storage.removeStorage("userInfo");
          this.$store.dispatch("user/clearUserInfo");
          this.$router.push({ path: "/" }).catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    userinfo() {
      this.$router.push({
        path: "/Set",
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "/src/css/base.css";

.header {
  height: 1.7rem;
  position: relative;
}

.headTop {
  position: relative;
  width: 100%;
  height: 0; // 本身不占用高度
  padding-top: 8.854%; // 用 padding 撑出 170/1920 的比例
  background: url(@/assets/image/logobackimg.png) center/cover no-repeat;
  box-sizing: border-box;
  padding-right: 3%;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
  .head_right {
    position: absolute;
    right: 3%;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    justify-content: flex-end;
    align-items: center;
    z-index: 99;
    .text {
      text-align: right;
      // font-size: 24px;
      font-size: 0.24rem;
      color: #4b3331;
      cursor: pointer;
    }
    .login {
      width: 0.6rem;
      height: 0.6rem;
      margin-left: 0.2rem;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
}
</style>